import { ChoferPartialModel } from 'app/chofer/models/Chofer';
import { domicilioBuilder } from 'app/domicilio/models/DomicilioModel';
import { passengerBuilder } from 'app/client/clientBusiness/Passenger/models/Passenger';
import moment from 'moment';
import {
  TransferReservationPartialModel,
  ViajeTrasladosGestionEstado
} from '../../viajeTraslado/models/TransferReservationPartial';

export type ManagementDriverSummary = Pick<
  ChoferPartialModel,
  'id' | 'codigo' | 'nombreCompleto' | 'businessUnit'
>;

export interface TransferReservationManagementListModel
  extends Pick<
    TransferReservationPartialModel,
    | 'id'
    | 'client'
    | 'entryChannel'
    | 'platformId'
    | 'hasPriority'
    | 'serviceType'
    | 'coordinationObservation'
    | 'general_observation'
    | 'reservationDatetime'
    | 'arrivalDateTime'
    | 'advanceHours'
    | 'locations'
    | 'state'
    | 'pay_with_cash'
    | 'type'
    | 'event_name'
    | 'lltpais'
    | 'airport_details'
  > {
  preAssignedDriver: ManagementDriverSummary | null;
  assigned_driver: ManagementDriverSummary | null;
  estimated_prices: { driver_price: number; kilometers: number } | null;
  calculated_prices: { driver_price: number; kilometers: number } | null;
  final_prices: { driver_price: number; kilometers: number } | null;
  cancellation_state:
    | (Omit<ViajeTrasladosGestionEstado, 'user'> & {
        user: ViajeTrasladosGestionEstado['user'] | null;
      })
    | null;
  bus_requirement: {
    id: number;
    provider_price: number;
    customer_price: number;
    bus_type: { id: number; name: string } | null;
    vehicle: { id: number; patent: string } | null;
  } | null;
}

const driverSummary = (driver): ManagementDriverSummary | null =>
  driver
    ? {
        id: driver.id,
        codigo: driver.code,
        nombreCompleto: driver.name,
        businessUnit: driver.business_units
      }
    : null;

export const transferReservationManagementListBuilder = {
  fromBackEnd: (reservation): TransferReservationManagementListModel => {
    // Accept the legacy response during a rolling deployment.
    const cancellation =
      reservation.cancellation_state ??
      reservation.states?.find((state) => state.type === 'Cancelado');

    return {
      ...reservation,
      reservationDatetime: moment(reservation.reservationDatetime),
      arrivalDateTime: moment(reservation.arrivalDatetime),
      preAssignedDriver: driverSummary(reservation.pre_assigned_driver),
      assigned_driver: driverSummary(reservation.assigned_driver),
      locations: reservation.locations.map((location) => ({
        ...location,
        address: domicilioBuilder.fromBackEnd(location.address),
        passengers: location.passengers.map(passengerBuilder.fromBackEnd)
      })),
      cancellation_state: cancellation
        ? {
            ...cancellation,
            observation:
              reservation.cancel_observation ?? cancellation.observation ?? ''
          }
        : null
    };
  }
};
